import React from "react";
import PropTypes from "prop-types";
import cn from "./style.module.scss";

export function List(props) {
  const className = `${cn.list} ${props.className}`;
  return <ul className={className}>{props.children}</ul>;
}

List.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

List.defaultProps = {
  className: "",
};
